const productsData = [
    {
        productName: 'Gray Vase',
        category: 'decoration',
        productPrice: 28.99,
        image: '/featuredProduct1.png',
        image2: '/featuredProduct1.png',
        productId: 1,
    },
    {
        productName: 'Portable Basket',
        category: 'furniture',
        productPrice: 14.99,
        image: '/featuredProduct2.png',
        image2: '',
        productId: 2,
    },
    {
        productName: 'Set of pots',
        category: 'decoration',
        productPrice: 21.99,
        image: '/featuredProduct3.png',
        image2: '',
        productId: 3,
    },
    {
        productName: 'Dog House',
        category: 'furniture',
        productPrice: 37.99,
        image: '/featuredProduct4.png',
        image2: '',
        productId: 4,
    },
    {
        productName: 'wooden loft table',
        category: 'furniture',
        productPrice: 78.99,
        image: '/featuredProduct5.png',
        image2: '',
        productId: 5,
    },
    {
        productName: 'decorative pillow',
        category: 'textile',
        productPrice: 12.99,
        image: '/featuredProduct6.png',
        image2: '',
        productId: 6,
    },
    {
        productName: 'travel mug for tea',
        category: 'decoration',
        productPrice: 11.99,
        image: '/featuredProduct7.png',
        image2: '',
        productId: 7,
    },
    {
        productName: 'set of dishes',
        category: 'furniture',
        productPrice: 18.99,
        image: '/featuredProduct8.png',
        image2: '',
        productId: 8,
    },
];

export default productsData;
